import { useState } from "react";
import { ModalComponent } from "..";
import { useLazyGetUserProfileQuery } from "../../../redux/features/auth/auth.api";
import { useUploadCooperativeByeLawsMutation } from "../../../redux/features/cooperative/cooperative.api";
import { FileUploadInput } from "../../inputs/fileUploadInput";

export const UploadConstitutionModal = ({
  modalOpen,
  onModalClose = () => {},
}: {
  modalOpen: boolean;
  onModalClose: () => void;
}) => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const [uploadDoc, { isLoading: uploadingDoc }] =
    useUploadCooperativeByeLawsMutation();

  const [fetchProfile] = useLazyGetUserProfileQuery();

  return (
    <ModalComponent
      isModalOpen={modalOpen}
      onModalClose={() => {
        setUploadedFiles([]);
        onModalClose();
      }}
      title="Bye Laws or Constitution"
      subTitle="Upload a document that defines cooperative’s governance structure, rules and decision-making processes."
      modalClassName=""
      isProceedDisabled={uploadedFiles.length < 1 || uploadingDoc}
      isLoading={uploadingDoc}
      onProceedClick={async () => {
        const formData = new FormData();
        formData.append("file", uploadedFiles[0]);

        const resp = await uploadDoc(formData);

        if (resp.data?.success) {
          setUploadedFiles([]);
          onModalClose();
          fetchProfile();
        }
      }}
    >
      <FileUploadInput
        maxNumberOfFiles={1}
        handleChange={(files) => {
          setUploadedFiles(files);
        }}
        selectedFiles={uploadedFiles}
        accept="image/*,.pdf"
        types="PNG, JPG, PDF"
      />
    </ModalComponent>
  );
};
